module.exports = __webpack_public_path__ + "img/photo_placeholder.44ea5afd.svg";